import type { PersistenceOptions } from "pinia-plugin-persistedstate";

export const persistConfig = (params: Omit<PersistenceOptions, "storage"> = {}, storageType: "session" | "local" = "session") => {
  const getStorage = () => (storageType === "local" ? window.localStorage : window.sessionStorage);

  return {
    storage: {
      getItem: (key: string) => getStorage().getItem(key),
      setItem: (key: string, value: string) => getStorage().setItem(key, value),
      removeItem: (key: string) => getStorage().removeItem(key),
    },
    ...params,
  };
}
